import React, { useEffect, useState, useCallback } from "react";
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import { MdClear, MdSearch } from 'react-icons/md';
import { FaCalendarAlt,
         FaRegClock,
         FaPrint,
         FaChevronRight,
         FaSatelliteDish
         } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import DatePicker from 'react-datepicker';
import Spinner from 'react-bootstrap/Spinner';
import Tab from 'react-bootstrap/Tab';

import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';

import "react-datepicker/dist/react-datepicker.css";
import { API } from 'aws-amplify';
import moment from 'moment';

import { useToasts } from 'react-toast-notifications';

import "./DataReport.scss";
import DataReportXls from './DataReportXls';

import VehCounts from './VehCounts';
import VehClass from './VehClass';
import Volume from './Volume';
import GapHeadway from './GapHeadway';
import Speed from './Speed';
// import SensorDiagnose from './SensorDiagnose';
import AirQuality from './AirQuality';
import Occupancy from './Occupancy';
import SafetyScore from "./SafetyScore";


const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const DataReport = (props) => {
    const { addToast } = useToasts();
    const [vehTotalCount, setVehTotalCount] = useState(0);
    const [pedTotalCount, setPedTotalCount] = useState(0);
    const [bikeTotalCount, setBikeTotalCount] = useState(0);
    const [lastUpd, setLastUpd ] = useState("Not Available");
    const [vehicleCount, setVehicleCount] = useState({});
    const [vehicleCountTbl, setVehicleCountTbl] = useState([]);
    const [vehicleCountZone, setVehicleCountZone] = useState({});
    const [vehicleCountZoneTbl, setVehicleCountZoneTbl] = useState([]);
    const [vehicleClass, setVehicleClass] = useState({});
    const [vehicleClassTbl, setVehicleClassTbl] = useState([]);
    const [asset, setAsset] = useState();
    const [img, setImg] = useState();
    const [assetName, setAssetName] = useState();
    const [aqsensor, setAQsensor] = useState();
    const [assets, setAssets] = useState([]);
    const [timeFrom, setTimeFrom] = useState(new Date().setHours(0,0,0));
    const [timeTo, setTimeTo] = useState(new Date().setHours(23,59,0));
    const [dateSel, setDateSel] = useState(new Date());
    const [dateSelTo, setDateSelTo] = useState(new Date());
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingCounts, setIsLoadingCounts] = useState(false);
    const [counts, setCounts] = useState([]);
    const [countsh, setCountsh] = useState([]);
    const [volumeTbl, setvolumeTbl] = useState([]);
    const [volumeGraph, setVolumeGraph] = useState([]);
    const [gap, setGap] = useState([]);
    const [gapZone, setGapZone] = useState([]);
    const [speed, setSpeed] = useState([]);
	const [location, setLocation] = useState('');
	const [locationList, setLocationList] = useState([]);
	const [assetList, setAssetList] = useState([]);
    const [countryList, setCountryList] = useState([]);
	const [country, setCountry] = useState('');
    const [zone, setZone] = useState({});
    const [zoneClass, setZoneClass] = useState([]);
    const [occup, setOccupancy] = useState({});
    const [occTbl, setOccupancyTbl] = useState([]);
    const [tabKey, setTabKey] = useState('counts');
    const [error, setError] = useState('');
    const [speedUnit, setSpeedUnit] = useState();
    const [safetyScore, setSafetyScore] = useState([]);

    // const [zoneCountsHr, setZoneCountsHrs] = useState([]);
    const chartColors = process.env.REACT_APP_CHART && process.env.REACT_APP_CHART.split(',');    


    let formatDate = ['DD-MM-YYYY','dd/MM/yyyy','DD/MM/YYYY, h a']
    if (props.formatDate!==formatDate[0]){
        formatDate = ['MM-DD-YYYY','MM/dd/yyyy','MM/DD/YYYY, h a']
    }

    const sum = (arr) => arr.reduce((a, b) => a + b, 0);
    const count_non_zeros = (arr) => arr.reduce((a, b) => b > 0 ? a + 1 : a, 0);
    const avg_excluding_zeros = useCallback((arr) => {
        if (arr.length === 0) {
          return 0;
        }
        const non_zeros = count_non_zeros(arr);
        if (non_zeros === 0) {
          return 0;
        }
        return parseFloat((sum(arr) / non_zeros).toFixed(2));
      },[]);

    // Load asset
    /* eslint-disable no-alert, no-console */
    useEffect(()=>{
        const fetchAssets = async () => {
            setIsLoading(true);


            let data = await API.get('asset','/', params)
            data.sort((a, b) => (a.name > b.name) ? 1 : -1)
            // data = data.filter(item => item.location === 'UK')

            //Get user asset list
            let user_assets = props.user.user_assets || []


            let assetsFiltered = []
            if (user_assets){
                assetsFiltered = data.filter(x => user_assets.find(i => i === x.id) && x.status === 'active');
            }


            if (assetsFiltered.length>0){
                setAssets(assetsFiltered);
                setAssetList(assetsFiltered);
            }
            setIsLoading(false);
        }

        if (props.user && props.user.user_assets)
            fetchAssets();

    }, [props.user]);

    // Load counts
    // Fetch hourly counts filter by asset, date and time range
    const fetchCounts = async () => {
        setIsLoadingCounts(true);
        const dtF = new Date(dateSel)
        const dtT = new Date(dateSelTo)

        const dtFrom = moment.utc(dtF).local().format('YYYY-MM-DD')
        const tiFrom = moment.utc(timeFrom).local().format('HH:mm:ss');
        let  dateStart = moment(dtFrom + ' ' + tiFrom).toISOString();

        const dtTo = moment.utc(dtT).local().format('YYYY-MM-DD')
        const tiTo = moment.utc(timeTo).local().format('HH:mm:ss');
        let  dateEnd = moment(dtTo + ' ' + tiTo).toISOString();


        if (dateEnd >= dateStart){
            const filter = asset +'?start='+ dateStart +'&end='+ dateEnd

            let data = []
            await API.get('hourly_counts','/'+ filter, params)
            .then(resp => {
                data = resp
            }).catch(error => {
                console.log(error)
                addToast('Error Loading Data', { appearance: 'error' });
                setIsLoadingCounts(false);
            });

            const dataFiltered = data.map((item, i) => {
                let zones = []
                let row = []
                    // Format array [{asset, date, entries}]
                    Object.keys(item).forEach((key) => {
                        if (typeof item[key] === 'object' && item[key] !== null) {
                        zones.push(item[key])
                        }
                    })
                    // console.log(zones)
                    zones.forEach((item) => {
                        Object.keys(item).forEach((key) => {
                            row.push({
                                CLASS: key,
                                VOLUME: item[key].VOLUME,
                                SPEED: item[key].SPEED,
                                GAP: item[key].GAP,
                                HEADWAY: item[key].HEADWAY,
                                OCCUPANCY: item[key].OCCUPANCY
                            })
                        })
                    })

                    return {
                        asset_id: item["asset_id"],
                        date_iso: item["date_iso"],
                        entries: row
                    }
                })

            const selAsset = assets.find(x => x.id === asset)
            // console.log(selAsset)
            setAssetName(selAsset.name);
            setAQsensor(selAsset.airscan_id);
            setSpeedUnit(selAsset.speed)
            setImg(selAsset.img)
            setCountsh(data)
            setCounts(dataFiltered);

        } else {
            addToast('Error incorrect dates', { appearance: 'error' });
        }
        setIsLoadingCounts(false);

    }

   // Load country
   useEffect(()=>{
    const fetchCountry = async () => {
        let loc = [...new Set(assets.map(item => item.country))];

        loc = loc.filter(item => item !== undefined);
        loc.sort((a, b) => (a > b) ? 1 : -1)

        if (loc.length === 1)
            setCountry(loc[0]);

        setCountryList(loc);
    }
    fetchCountry();

    }, [assets]);

    // Load location
    useEffect(()=>{
    const fetchLocation = async () => {
        let loc=[]
        if (country){
            loc = [...new Set(assets.filter(item => item.country === country).map(item => item.location))];
        }else{
            loc = [...new Set(assets.map(item => item.location))];
        }
        loc.sort((a, b) => (a > b) ? 1 : -1)
        loc = loc.filter(item => item !== undefined);
        setLocationList(loc);
    }
    fetchLocation();
    }, [assets, country]);

    useEffect(() => {
        const handleSearch = () => {
            let results = assets;
            // country
            if (country){
                results = results.filter(results =>
                    results.country && results.country.toLowerCase().includes(country.toLowerCase())
            )}
            // Location
            if (location){
                results = results.filter(results =>
                    results.location && results.location.toLowerCase().includes(location.toLowerCase())
            )}

            setAssetList(results);
        }
		handleSearch();
    }, [location, country, assets]);

    // Get the time of the last update
    useEffect(() => {
        const isValidDate = (d) => { return d instanceof Date && !isNaN(d); };
        const fetchLastEntry = async () => {
            const asset_upd = await API.get('asset','/' + asset, params)
            const date = new Date(asset_upd.last_update)
            if (isValidDate(date)) {
                // setLastUpd(date.toLocaleString(process.env.REACT_APP_DATE_LOCALE));
                setLastUpd(moment.utc(date).local().format(formatDate[2]));
            }else{
                setLastUpd("Not Available");
            }
        }
        if (asset)
            fetchLastEntry();
    }, [asset, formatDate, counts]);


    // Graph options
    const options = {
        maintainAspectRatio: false,
        legend: {
            display: true
        },
        scales: {
            y: { ticks: { beginAtZero: true } },
        },
        plugins: {
            customCanvasBackgroundColor: {
              color: 'lightGreen',
            },
            datalabels: { display: false }
          },
    };


    const handleClearSearch = () => {
		setTimeFrom(new Date().setHours(0,0,0));
        setTimeTo(new Date().setHours(23,59,0));
		// setAsset(assets[0].id);
		setAssetName('');
		setAQsensor('');
		setAsset('');
		setDateSel(new Date());
		setDateSelTo(new Date());
        setCounts([]);
        setCountsh([]);
        if (countryList.length === 1)
            setCountry(countryList[0]);
        else
            setCountry('');
        // if (locationList.length === 1)
        //     setLocation(locationList[0]);
        // else
        setLocation('');
        setError('');
    }

    const handleSearch = () => {
        setZone({});
        if (asset){
            setError("");
            setTabKey('counts');
            fetchCounts();
        }else{
            setError("Required");
        }
    }

    const startTime = new Date();
    startTime.setHours(23,59,0);

    const pause = ms => new Promise(resolve => setTimeout(resolve, ms));

    const handlePrint = async () => {
        setTabKey('classification');
        await pause(1000);
        setTabKey('volume');
        await pause(1000);
        setTabKey('occupancy');
        await pause(1000);
        // setTabKey('airq');
        // await pause(500);       
        setTabKey('counts');
        window.print();
    }

return (

    <div className="DataReport">
        <div className="col-md-12">
            <div className="row header">
                <div className="col-8"> Vehicle Detector Report</div>   
            </div>
        </div>
        {(!isLoading) ? (
        <div>
        <div className="col-md-12 pt-0 div-content">
        <div className="row">
            <div className="col-12 p-2 d-flex rounded bg-light">
                <div className="col-8">
                <div className="row">
                    <div className="col-md-6">
                        <div className="row">
                        <div className="col-md-4">
                        <Form.Group controlId="country">
                            <Form.Label>Country</Form.Label>
                            <Form.Control
                                as="select"
                                value={country}
                                onChange={e => {setCountry(e.target.value)}}>
                                    <option value="">Country</option>
                                    {countryList.map((item, i) =>
                                        <option key={`country`+i} value={item}>{item}</option>
                                        )}

                            </Form.Control>
                        </Form.Group>
                        </div>
                        <div className="col-md-8">
                        <Form.Group controlId="location" >
                        <Form.Label>Location</Form.Label>
                            <Form.Control
                                as="select"
                                value={location}
                                onChange={e => {setLocation(e.target.value)}}>
                                    <option key='locs' value=''>Location</option>
                                    {locationList.map((item, i) =>
                                        <option key={`loc`+i} value={item}>{item}</option>
                                        )}
                            </Form.Control>
                        </Form.Group>
                        </div>
                        </div>
                        <Form.Group controlId="asset" >
                            <Form.Label>Asset</Form.Label>
                            <Form.Control
                                as="select"
                                value={asset}
                                onChange={e => {
                                    setError("");
                                    setAsset(e.target.value);}}
                                >
                                <option key='assetList' value=''>Asset</option>
                                {assetList.map((item, i) =>
                                <option key={item.id} value={item.id}>{item.name}</option>
                                )}
                            </Form.Control>
                            <div className="error-message">{error}</div>
                        </Form.Group>
                    </div>
                    <div className="col-md-3">
                        <Form.Group controlId="date_from">
                        <Form.Label><FaCalendarAlt className="text-secondary" /> Date From</Form.Label>
                        <div>
                        <DatePicker
                            dateFormat={formatDate[1]}
                            selected={dateSel}
                            onChange={(dateSel) => {setDateSel(dateSel)}}
                            minDate={new Date(moment().add(-1, 'month'))}
                            maxDate={new Date()}
                            className="form-control" />
                        </div>
                        </Form.Group>

                        <Form.Group controlId="date_to">
                        <Form.Label><FaCalendarAlt className="text-secondary" /> Date To</Form.Label>
                        <div>
                        <DatePicker
                            dateFormat={formatDate[1]}
                            selected={dateSelTo}
                            onChange={(dateSelTo) => {setDateSelTo(dateSelTo)}}
                            minDate={new Date(moment().add(-1, 'month'))}
                            maxDate={new Date()}
                            className="form-control"/>
                        </div>
                        </Form.Group>
                    </div>
                    <div className="col-md-3">
                    <Form.Group controlId="time_from">
                        <Form.Label><FaRegClock className="text-secondary" /> Time From</Form.Label>
                        <div>
                        <DatePicker
                            selected={timeFrom}
                            onChange={date => setTimeFrom(date)}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={60}
                            timeCaption="Time"
                            dateFormat="HH:mm"
                            timeFormat="HH:mm"
                            className="form-control"
                            injectTimes={[
                                startTime
                            ]}
                            />
                        </div>
                        </Form.Group>

                        <Form.Group controlId="time_to">
                        <Form.Label><FaRegClock className="text-secondary" /> Time To</Form.Label>
                        <div>
                        <DatePicker
                            selected={timeTo}
                            onChange={date => setTimeTo(date)}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={60}
                            timeCaption="Time"
                            dateFormat="HH:mm"
                            timeFormat="HH:mm"
                            className="form-control"
                            injectTimes={[
                                startTime
                            ]}
                            />
                        </div>
                        </Form.Group>
                        </div>

                    </div>

                </div>
                <div className="col-2 text-nowrap">

                    <Button variant="info" size="sm" onClick={handleSearch} className="mr-1 text-nowrap"
                    disabled = {isLoadingCounts? true : false}
                    >
                        <MdSearch /> Search
                    </Button>

                    <Button variant="danger" size="sm" onClick={handleClearSearch} >
                        <MdClear />
                    </Button>

                </div>

                <div className="col-2 d-flex align-items-end flex-column">
                    <div className="text-right print">
                        <DataReportXls
                            vehCount={vehicleCountTbl}
                            vehClass={vehicleClassTbl}
                            gap={gap}
                            speed={speed}
                            volume={volumeTbl}
                            occupancy={occTbl}
                            dateFrom={dateSel}
                            dateTo={dateSelTo}
                            formatDate={formatDate}
                            asset={assetName}
                            />
                        <Button variant="light" className="mb-1" size="sm" onClick={handlePrint
                            // () => {
                            // setTabKey('classification');
                            // setTabKey('volume');
                            // setTabKey('occupancy');
                            // setTabKey('counts');
                            // window.print()} 
                            }>
                            <FaPrint /> Print
                        </Button><br/>   
                        {(img)?                   
                        <Button variant="light" className="mb-1" size="sm" onClick={() => window.open(img,'_blank')}>
                            <FaSatelliteDish /> Image
                            {/* style = {{transform: 'rotate(90deg)' }}  */}
                        </Button>
                        :''}
                    </div>
                    <div className="small mt-auto text-right text-secondary">
                        Asset ID: {asset} <br/>
                        Last Update: {lastUpd}
                    </div>
                </div>
            </div>
            </div>
            <Tab.Container 
                id="left-tabs-example" 
                defaultActiveKey="counts"
                activeKey={tabKey}
                onSelect={(k) => setTabKey(k)}
            >
                <Row>
                    <Col sm={2} className="m-0 no-print">
                    <Nav variant="pills" className="navbar flex-column" >
                        <Nav.Item>
                        <Nav.Link eventKey="counts">Vehicle Count <FaChevronRight className="text-white float-right" /></Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="classification">Classification <FaChevronRight className="text-white float-right" /></Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="volume">Volume <FaChevronRight className="text-white float-right" /></Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="occupancy">Occupancy <FaChevronRight className="text-white float-right" /></Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="gaphead">Gap & Headway <FaChevronRight className="text-white float-right" /></Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="speed">Speed <FaChevronRight className="text-white float-right" /></Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="safety">(Beta) Safety Score <FaChevronRight className="text-white float-right" /></Nav.Link>
                        </Nav.Item>
                        {(aqsensor) ?
                        <Nav.Item>         
                        <Nav.Link eventKey="airq">Air Quality <FaChevronRight className="text-white float-right" /></Nav.Link>
                        </Nav.Item>
                        :''}
                        {/* <Nav.Item>
                        <Nav.Link eventKey="diagnose">Sensor Diagnose <FaChevronRight className="text-white float-right" /></Nav.Link>
                        </Nav.Item> */}
                    </Nav>
                    </Col>
                    <Col sm className="resize-print border-left border-light">
                    <Tab.Content>
                        <Tab.Pane eventKey="counts">
                            {/* Vehicle Counts */}
                            <VehCounts
                                isLoadingCounts={isLoadingCounts}
                                pedTotalCount={pedTotalCount}
                                bikeTotalCount={bikeTotalCount}
                                vehTotalCount={vehTotalCount}
                                vehicleCount={vehicleCount}
                                options={options}
                                assetName={assetName}
                                vehicleCountTbl={vehicleCountTbl}
                                counts={counts}
                                setVehicleCountTbl={setVehicleCountTbl}
                                setPedTotalCount={setPedTotalCount}
                                setVehTotalCount={setVehTotalCount}
                                setBikeTotalCount={setBikeTotalCount}
                                setVehicleCount={setVehicleCount}
                                chartColors={chartColors}
                             />
                        </Tab.Pane>
                        <Tab.Pane eventKey="classification">
                            {/* Vehicle Class */}
                            <VehClass
                                vehicleClass={vehicleClass}
                                options={options}
                                assetName={assetName}
                                vehicleClassTbl={vehicleClassTbl}
                                setVehicleClass={setVehicleClass}
                                setVehicleClassTbl={setVehicleClassTbl}
                                counts={counts}
                                chartColors={chartColors}
                             />
                        </Tab.Pane>
                        <Tab.Pane eventKey="volume">
                            {/* Volume */}
                            <Volume
                                volumeGraph={volumeGraph}
                                volumeTbl={volumeTbl}
                                options={options}
                                assetName={assetName}
                                zone={zone}
                                vehicleCountZone={vehicleCountZone}
                                zoneClass={zoneClass}
                                gapZone={gapZone}
                                vehicleCountZoneTbl={vehicleCountZoneTbl}
                                dateSel={dateSel}
                                dateSelTo={dateSelTo}
                                formatDate={formatDate}
                                setZone={setZone}
                                setZoneClass={setZoneClass}
                                countsh={countsh}
                                setVolumeGraph={setVolumeGraph}
                                setvolumeTbl={setvolumeTbl}
                                assets={assets}
                                asset={asset}
                                setGapZone={setGapZone}
                                setVehicleCountZone={setVehicleCountZone}
                                setVehicleCountZoneTbl={setVehicleCountZoneTbl}
                                chartColors={chartColors}
                             />
                        </Tab.Pane>
                        <Tab.Pane eventKey="occupancy">
                            {/* Occupancy */}
                            <Occupancy
                                options={options}
                                assetName={assetName}
                                counts={counts}
                                formatDate={formatDate}
                                occup={occup}
                                setOccupancy={setOccupancy}
                                occTbl={occTbl}
                                setOccupancyTbl={setOccupancyTbl}
                                avg_excluding_zeros={avg_excluding_zeros}
                                chartColors={chartColors}
                             />
                        </Tab.Pane>
                        <Tab.Pane eventKey="gaphead">
                            {/* Gap and Headway */}
                            <GapHeadway
                                gap={gap}
                                setGap={setGap}
                                counts={counts}
                                formatDate={formatDate}
                                avg_excluding_zeros={avg_excluding_zeros}                               
                             />
                        </Tab.Pane>
                        <Tab.Pane eventKey="speed">
                            {/* Speed */}
                            <Speed
                                // speed={speed}
                                counts={counts}
                                speed={speed}
                                setSpeed={setSpeed}
                                formatDate={formatDate}
                                avg_excluding_zeros={avg_excluding_zeros}
                                speedUnit={speedUnit}
                             />
                        </Tab.Pane>
                        <Tab.Pane eventKey="safety">
                            {/* Safety Score */}
                            <SafetyScore
                                // speed={speed}
                                asset={asset}
                                dateSel={dateSel}
                                dateSelTo={dateSelTo}
                                timeFrom={timeFrom}
                                timeTo={timeTo}
                                counts={counts}
                                safetyScore={safetyScore}
                                setSafetyScore={setSafetyScore}
                                formatDate={formatDate}
                                avg_excluding_zeros={avg_excluding_zeros}
                                speedUnit={speedUnit}
                             />
                        </Tab.Pane>
                        {(aqsensor) ?
                        <Tab.Pane eventKey="airq">
                            {/* Air Quality */}
                            <AirQuality
                                options={options}
                                assetName={assetName}
                                isLoadingCounts={isLoadingCounts}
                                asset={asset}
                                dateSel={dateSel}
                                dateSelTo={dateSelTo}
                                timeFrom={timeFrom}
                                timeTo={timeTo}
                                params={params}
                            />
                        </Tab.Pane>
                        :''}
                        {/* <Tab.Pane eventKey="diagnose"> */}
                            {/* Sensor Diagnose / Health Check */}
                            {/* <SensorDiagnose
                                options={options}
                                assetName={assetName}
                                isLoadingCounts={isLoadingCounts}
                                asset={asset}
                                dateSel={dateSel}
                                dateSelTo={dateSelTo}
                                timeFrom={timeFrom}
                                timeTo={timeTo}
                                params={params}
                            />
                        </Tab.Pane> */}
                    </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>

        </div>
        </div>
        ):(
            <div className="col-md-12">
            <Spinner animation="grow" size="sm" role="status" variant="warning" />
            <span className="text-dark">  Loading...</span>
            </div>
            )}
    </div>
)
}


const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
    };
  };

export default connect(mapStateToProps)(DataReport);


